var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 630,
    height: 582,
    viewBox: "0 0 630 582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #1b2e35;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        stroke: #33e0a0;\n        stroke-width: 3.79px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flower_R",
    "data-name": "flower R"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.831,180.464a18.782,18.782,0,1,0,18.762,18.782A18.772,18.772,0,0,0,506.831,180.464Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 491.656,
    cy: 226.688,
    r: 18.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.166,207.9a18.782,18.782,0,1,0,18.761,18.782A18.771,18.771,0,0,0,521.166,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.41,201.24a16.672,16.672,0,1,0,16.653,16.672A16.662,16.662,0,0,0,506.41,201.24Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard3);
export default __webpack_public_path__ + "static/media/Artboard 3.e126b75b8c812faa08ac1b883ec2aa2f.svg";
export { ForwardRef as ReactComponent };